"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4316],{

/***/ 94316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ vertical_tabs_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-tabs/vertical-tabs.js + 12 modules
var vertical_tabs = __webpack_require__(54837);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/vertical-tabs/vertical-tabs-component.scss.js

var StyledVerticalTabsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12lv7gh0"
})();

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-tabs/default-props.js
var default_props = __webpack_require__(66442);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/vertical-tabs/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var vertical_tabs_default_props = (_object_spread({}, default_props/* default */.Z));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/vertical-tabs/vertical-tabs-component.js
function vertical_tabs_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tabs_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tabs_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var VerticalTabsComponent = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledVerticalTabsComponent, {
        className: "vertical-tabs-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(vertical_tabs/* default */.Z, vertical_tabs_component_object_spread({}, props))
    });
};
VerticalTabsComponent.defaultProps = vertical_tabs_default_props;
/* harmony default export */ var vertical_tabs_component = (VerticalTabsComponent);


/***/ })

}]);